import axios from 'axios'

export default {
    namespaced: true,
    state: {
        communications: [],
        communication: {},
        communicationDeliveryLog: [],
        communicationAttachments: [],
    },
    mutations: {
        SET_COMMUNICATIONS(state, payload) {
            state.communications = payload;
        },
        SET_COMMUNICATION(state, payload) {
            state.communication = payload;
        },
        SET_COMMUNICATION_DELIVERY_LOG(state, payload) {
            state.communicationDeliveryLog = payload;
        },
        SET_COMMUNICATION_ATTACHMENTS(state, payload) {
            state.communicationAttachments = payload;
        },
    },
    actions: {
        FetchCommunicationsByStudentID({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/communications/fetch/studentid`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            if (!!response.data.payload) {
                                response.data.payload.forEach(p => {
                                    p.sender = CoalesceJSON(p.sender);
                                    p.recipients = CoalesceJSON(p.recipients);
                                    p.ccRecipients = CoalesceJSON(p.ccRecipients);
                                    p.bccRecipients = CoalesceJSON(p.bccRecipients);
                                    p.replyTo = CoalesceJSON(p.replyTo);
                                });
                            }
                            commit('SET_COMMUNICATIONS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCommunicationsByStudentID: ${error.message}`));
            });
        },
        FetchCommunication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/communications/communication/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload.sender = CoalesceJSON(response.data.payload.sender);
                            response.data.payload.recipients = CoalesceJSON(response.data.payload.recipients);
                            response.data.payload.ccRecipients = CoalesceJSON(response.data.payload.ccRecipients);
                            response.data.payload.bccRecipients = CoalesceJSON(response.data.payload.bccRecipients);
                            response.data.payload.replyTo = CoalesceJSON(response.data.payload.replyTo);

                            commit('SET_COMMUNICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCommunication: ${error.message}`));
            });
        },
        FetchCommunicationDeliveryLog({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/communications/communication/delivery-log/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_COMMUNICATION_DELIVERY_LOG', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCommunicationDeliveryLog: ${error.message}`));
            });
        },
        FetchCommunicationAttachments({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/communications/communication/attachments/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_COMMUNICATION_ATTACHMENTS', response.data.payload);
                            resolve(response.data.message);
                        }
                        else reject(response.data.message);
                    }).catch(error => reject(`FetchCommunicationAttachments: ${error.response.data || error.message}`));
            });
        },
    },
    getters: {
        Communications(state) { return state.communications; },
        Communication(state) { return state.communication; },
        CommunicationDeliveryLog(state) { return state.communicationDeliveryLog; },
        CommunicationAttachments(state) { return state.communicationAttachments; },
    },
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
